function t(t, n) {
  var e = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && n.indexOf(r) < 0 && (e[r] = t[r]);
  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(t); o < r.length; o++) n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (e[r[o]] = t[r[o]]);
  }
  return e;
}
function n(t, n, e, r) {
  return new (e || (e = Promise))(function (o, c) {
    function p(t) {
      try {
        u(r.next(t));
      } catch (t) {
        c(t);
      }
    }
    function f(t) {
      try {
        u(r.throw(t));
      } catch (t) {
        c(t);
      }
    }
    function u(t) {
      var n;
      t.done ? o(t.value) : (n = t.value, n instanceof e ? n : new e(function (t) {
        t(n);
      })).then(p, f);
    }
    u((r = r.apply(t, n || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError;
export { n as __awaiter, t as __rest };